export default __webpack_public_path__ + "static/media/Cevil.2f761e65.jpg";